import React from "react";
import Icon from "../icon/Icon";
import { AdvancedMarker, APIProvider, Map } from "@vis.gl/react-google-maps";
import { googleMapsApiKey } from "./googleMapsConfig";

const containerStyle = {
  width: "400px",
  height: "400px",
};

interface MapContainerProps {
  center?: google.maps.LatLngLiteral;
  zoom?: number;
  width?: string;
  height?: string;
}

const MapContainer = ({ center, width, height }: MapContainerProps) => {
  return (
    <APIProvider apiKey={googleMapsApiKey}>
      <Map
        style={{
          width: width ?? containerStyle.width,
          height: height ?? containerStyle.height,
        }}
        defaultCenter={center}
        defaultZoom={15}
        gestureHandling={"greedy"}
        disableDefaultUI={true}
        mapId="contact_map"
      >
        {center && (
          <AdvancedMarker position={center}>
            <Icon name="map-marker" />
          </AdvancedMarker>
        )}
      </Map>
    </APIProvider>
  );
};

export default React.memo(MapContainer);
